import { render } from "./InternetRenewals.vue?vue&type=template&id=3ce85f8e&scoped=true"
import script from "./InternetRenewals.vue?vue&type=script&lang=js"
export * from "./InternetRenewals.vue?vue&type=script&lang=js"

import "./InternetRenewals.vue?vue&type=style&index=0&id=3ce85f8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce85f8e"]])

export default __exports__